'use client';

import type {
  ChangeEvent,
  Dispatch,
  SetStateAction,
} from 'react';
import type { LocaleType } from '~/model/GlobalTypes';
import { VtmnTextInput } from '@vtmn/react';
import { useTranslations } from 'next-intl';
import { useLayoutEffect, useState } from 'react';
import { Element } from 'react-scroll';
import { MainColumn } from '@/app/components/MainColumn';
import { BeardmanTalking } from '~/components/Beardman/BeardmanTalking/BeardmanTalking';
import { journeyColumnTemplate } from '~/components/Journey/config';
import { useFocus } from '~/hooks/useFocus';

export const EmailTypeQuestion = ({
  userEmail,
  userLanguage,
  setUserEmail,
  error = false,
  valid = false,
}: {
  userEmail: string;
  userLanguage: LocaleType;
  setUserEmail: Dispatch<SetStateAction<string>>;
  error?: boolean;
  valid?: boolean;
}) => {
  const t = useTranslations('FORM.EMAIL');
  const [inputRef, setInputFocus] = useFocus();
  const [isErrorDisplayed, setIsErrorDisplayed] = useState(!!error);

  const handleChange = (
    event: ChangeEvent<HTMLTextAreaElement> & ChangeEvent<HTMLInputElement>,
  ) => {
    setIsErrorDisplayed(false);
    setUserEmail(event.target.value);
  };

  useLayoutEffect(() => {
    setInputFocus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputRef.current]);

  return (
    <div data-testid="question-email" className="question">
      <Element
        aria-labelledby="questionTitle"
        name="question-email"
        role="fieldset"
      >
        <BeardmanTalking
          title={(
            <label
              lang={userLanguage}
              htmlFor="question-email"
              id="questionTitle"
              data-cy="questionTitle"
              data-testid="questionTitle"
            >
              {t('TITLE')}
            </label>
          )}
        />
        <div data-testid="form-fieldset" className="form-fieldset">
          <MainColumn column={journeyColumnTemplate}>
            <div className="vtmn-text-input_container">
              <VtmnTextInput
                type="email"
                identifier="question-email"
                placeholder="johndoe@gmail.com"
                ref={inputRef}
                value={userEmail}
                onChange={handleChange}
                labelText={t('LABEL')}
                helperText={t('HELPER')}
                onBlur={() => setIsErrorDisplayed(error)}
                {...(valid && { valid })}
                {...(isErrorDisplayed
                  && error && {
                  error,
                })}
              />
            </div>
          </MainColumn>
        </div>
      </Element>
    </div>
  );
};
